import * as React from 'react';
import { noop } from 'lodash';
import Spinner from '@atlaskit/spinner';
import { SPINNER_DELAY } from '@atlassian/help-center-common-component/constants';
import { LoadingRoot, SPINNER_SIZE } from './styled';

interface LoadingProps {
    className?: string;
    isRelative?: boolean;
}

class LoadingResult extends React.PureComponent<LoadingProps> {
    render() {
        return (
            <LoadingRoot {...this.props} data-test-id="search-results-loader">
                <Spinner
                    delay={SPINNER_DELAY}
                    invertColor={false}
                    onComplete={noop}
                    size={SPINNER_SIZE.unitless}
                    isCompleting={false}
                />
            </LoadingRoot>
        );
    }
}

export default LoadingResult;
